<template>
  <div>
    <!-- 页脚 -->
    <footer id="contact">
      <div class="container">
        <div class="footer-content">
          <div class="footer-column">
            <h3>{{ $t('foot_title_about') }}</h3>
            <p>{{ $t('foot_about') }}</p>
            <div class="social-links">
              <a href="#"><i class="fa fa-facebook"></i></a>
              <a href="#"><i class="fa fa-twitter"></i></a>
              <a href="#"><i class="fa fa-linkedin"></i></a>
              <a href="#"><i class="fa fa-instagram"></i></a>
            </div>
          </div>
          <div class="footer-column">
            <h3>{{ $t('foot_title_contact') }}</h3>
            <p><i class="fa fa-map-marker"></i>  {{ $t('foot_address') }} </p>
            <p><i class="fa fa-phone"></i> +86 10 8888 8888</p>
            <p><i class="fa fa-envelope"></i> info@innovatetech.com</p>
          </div>
          <div class="footer-column">
            <h3>{{ $t('foot_title_quick') }} </h3>
            <ul>
              <li v-for="(item, index) in $t('navItems')" :key="index">
                <a @click="handleClickNavbar(item.id)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="copyright">
          <p>&copy; 2020-2025 InnovateTech Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: `Footer`,
  data() {
    return {};
  },
  methods: {
    handleClickNavbar(val) {
      if (this.$store.state.activeNavbar !== val) {
        this.$router.push(val)
        this.$store.commit('setActiveNavbar', val)
      }
    }
  }
}
</script>

<style scoped>

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页脚样式 */
footer {
  background-color: rgba(18, 18, 18, 0.8);
  padding: 30px 0 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-column h3 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  color: #e0e0e0;
}

.footer-column h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(to right, #1a73e8, #1a73e8);
}

.footer-column p, .footer-column li {
  margin-bottom: 15px;
  color: #9e9e9e;
}

.footer-column ul {
  list-style: none;
  margin-left: -37px;
}

.footer-column a {
  color: #9e9e9e;
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.footer-column a:hover {
  color: #1a73e8;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-links a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.social-links a:hover {
  background: linear-gradient(135deg, #1a73e8 0%, #1a73e8 100%);
  transform: translateY(-3px);
}

.copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  color: #9e9e9e;
}

</style>
